import { render } from "./MrentedvehiclesCreate.vue?vue&type=template&id=17bc20ee&scoped=true"
import script from "./MrentedvehiclesCreate.vue?vue&type=script&lang=js"
export * from "./MrentedvehiclesCreate.vue?vue&type=script&lang=js"

import "./MrentedvehiclesCreate.vue?vue&type=style&index=0&id=17bc20ee&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bc20ee"]])

export default __exports__